import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  languageButton: {
    position: 'absolute',
    right: 20,
    top: 8,
  },
}));

export default useStyles;
